// extracted by mini-css-extract-plugin
export default {"container":"EditContact_container__aV2Z-","buttonDiv":"EditContact_buttonDiv__AGADA","updateButton":"EditContact_updateButton__7JDNX","cancle":"EditContact_cancle__GS01w"};